import { Select } from "antd";
import type { CSSProperties } from "react";
import { useIntl } from "react-intl";
import SelectCompetition from "~components/SelectCompetition/SelectCompetition.tsx";
import SelectSeason from "~components/SelectSeason/SelectSeason.tsx";
import { ConductStatuses } from "~enums/conductStatuses.ts";
import { ConductTypes } from "~enums/conductTypes.ts";
import type { ConductFilter } from "~pages/Conducts/types/conductFilter.ts";
import { sortStringValues } from "~utils/utilities.ts";

const statuses = Object.values(ConductStatuses)
  .sort(sortStringValues)
  .map((item) => ({ label: item, value: item }));
const conductTypes = Object.values(ConductTypes)
  .sort(sortStringValues)
  .map((item) => ({ label: item, value: item }));

const selectStyle: CSSProperties = { minWidth: 180, width: "100%" };

type Props = {
  filter: ConductFilter;
  onFilterChanged: (newFilter: ConductFilter) => void;
  loading: boolean;
};

const ConductFilters = ({ filter, loading, onFilterChanged }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <div style={{ display: "flex", gap: 5 }}>
      <SelectCompetition
        value={filter.competition}
        placeholder={formatMessage({ id: "competitionname" })}
        onChange={(value) => {
          onFilterChanged({ ...filter, competition: value, season: null });
        }}
        disabled={loading}
        style={selectStyle}
      />
      <SelectSeason
        placeholder={formatMessage({ id: "seasonname" })}
        disabled={!filter.competition || loading}
        competitionId={filter.competition?.value}
        onChange={(value) => {
          onFilterChanged({ ...filter, season: value });
        }}
        value={filter.season}
        style={selectStyle}
      />
      <Select
        onChange={(value) => {
          onFilterChanged({ ...filter, conductType: value });
        }}
        style={selectStyle}
        placeholder={formatMessage({ id: "conductType" })}
        allowClear
        showSearch={false}
        options={conductTypes}
        value={filter.conductType}
        mode={"multiple"}
        disabled={loading}
        maxTagCount={1}
        maxTagTextLength={10}
      />
      <Select
        onChange={(value) => {
          onFilterChanged({ ...filter, status: value });
        }}
        style={selectStyle}
        placeholder={formatMessage({ id: "status" })}
        allowClear
        options={statuses}
        value={filter.status}
        disabled={loading}
        showSearch={false}
      />
    </div>
  );
};

export default ConductFilters;
